import { render, staticRenderFns } from "./NewPayerForm.vue?vue&type=template&id=02fefdc0"
import script from "./NewPayerForm.vue?vue&type=script&lang=js"
export * from "./NewPayerForm.vue?vue&type=script&lang=js"
import style0 from "./NewPayerForm.vue?vue&type=style&index=0&id=02fefdc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports